"use client";

import { Box, Pagination, PaginationItem } from "@mui/material";
import { useSiteSearchContext } from "./SiteSearchContext";
import NextLink from "next/link";

export default function ProductsPagination() {
  const { totalPages, currentPage, maxInfinitePages, handlePageChange, getPagePath, endOfListRef, isFetchingNewPageItems } =
    useSiteSearchContext();
  if (totalPages <= 1) {
    return <></>;
  }
  return (
    <>
      <Box ref={endOfListRef} sx={{ width: "100%", height: "0.1px", backgroundColor: "transparent" }}></Box>
      <Pagination
        count={totalPages}
        sx={{ mx: "auto" }}
        color="primary"
        page={currentPage}
        renderItem={(item) => {
          const path = getPagePath(Number(item.page));
          return (
            <PaginationItem
              component={NextLink}
              href={`${path}`}
              {...item}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handlePageChange(Number(item.page));
              }}
            />
          );
        }}
      />
    </>
  );
}
